import { Injectable, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppLayoutModule } from "./layout/app.layout.module";

import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpBackend,
} from "@angular/common/http";

import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CookieService } from "ngx-cookie-service";
import { RouterModule } from "@angular/router";
import { UserModule } from "./modules/user/user.module";
import { MenusModule } from "./modules/menus/menus.module";
import { AppRoutingModule } from "./app-routing.module";
import { CommonModule } from "@angular/common";

import { HttpErrorInterceptor } from "./modules/api/interceptors/http-error.interceptor";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BreadCrumbModule } from "./modules/breadcrumbs/breadcrumbs.module";
import { TmsToolsModule } from "./modules/tms-tools/tms-tools.module";

import { MessagesModule } from 'primeng/messages';
import { CatalogCloudModule } from "./modules/catalog-cloud/catalog-cloud.module";
import { FascicleService } from "./modules/catalog-cloud/services/fascicle.service";
import { CatalogService } from "./modules/catalog-cloud/services/catalog.service";
import { DialogService } from "primeng/dynamicdialog";
import { PrimeFormGeneratorModule } from "@nousmedis/ngx-primeng-generator";
import { FormlyModule } from "@ngx-formly/core";

import { ConfirmationService, MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";
import { MenubarModule } from "primeng/menubar";
import { BackupModule } from "./modules/backups/backup.module";
import { ConfirmDialogModule } from "primeng/confirmdialog";

import { NmGuardAuthModule } from "@nousmedis/nm-guard-auth";
import { environment } from "environment";


export function httpTranslateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@Injectable({ providedIn: "root" })
export class HttpClientTrans extends HttpClient {
  constructor (handler: HttpBackend) {
    super(handler);
  }
}

export function HttpLoaderFactory(httpClient: HttpClientTrans) {
  return new TranslateHttpLoader(httpClient, "/assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserModule,
    RouterModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    BreadCrumbModule,
    TmsToolsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClientTrans],
      },
    }),
    NmGuardAuthModule.forRoot({
      authServerUrl: environment.auth_server,
      tokenKey: environment.app_cookie_name,
      orgKey: environment.user_current_org_cookie,
      loginRoute: '/login',
      dashRoute: '/dash',
    }),
    AppRoutingModule,
    UserModule,
    MenusModule,
    TmsToolsModule,
    ToastModule,
    CatalogCloudModule,
    MessagesModule,
    MenubarModule,
    PrimeFormGeneratorModule,
    FormlyModule.forRoot(),
    AppLayoutModule,
    BackupModule,
    ConfirmDialogModule,
  ],
  exports: [TranslateModule],

  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    CookieService,
    MessageService,
    FascicleService,
    CatalogService,
    DialogService,
    ConfirmationService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
